import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { formatAmountByDecimals } from '../../../../packages/utils/numberFormatting';
import { useUtxEarnOffersGet } from '@utx/utx-client';
import { CurrenciesContext } from '@/currencies/currency.context';

interface UseOfferDetailsParams {
  offerId: string;
}

export const useOfferDetails = (params: UseOfferDetailsParams) => {
  const { offerId } = params;
  const query = useUtxEarnOffersGet(offerId, {
    query: {
      enabled: !!offerId
    }
  });

  const { t } = useTranslation('earn');
  const { getDecimalByAsset } = useContext(CurrenciesContext);

  const textDetailsData = useMemo(() => {
    if (!query.data) return [];
    const data = query.data.data;
    const minSubscriptionAmount = data.minSubscriptionAmount
      ? formatAmountByDecimals({ value: data.minSubscriptionAmount, decimals: getDecimalByAsset(data.asset), suffix: data.asset })
      : ' - ';
    const maxSubscriptionAmount = data.minSubscriptionAmount
      ? formatAmountByDecimals({ value: data.maxSubscriptionAmount, decimals: getDecimalByAsset(data.asset), suffix: data.asset })
      : ' - ';

    return [
      { name: t('earn-invest::glossary.min-subscription-amount'), data: minSubscriptionAmount },
      { name: t('earn-invest::glossary.max-subscription-amount'), data: maxSubscriptionAmount }
    ];
  }, [query]);

  return {
    ...query,
    textDetailsData
  };
};
